import { setCurrentLocation } from '@/core/redux/currentLocationSlice';
import { RootState } from '@/core/redux/store';
import { getData } from '@/services/api.service';
import { routePrefix } from '@/utils/routes/routes';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router';

interface PostCodeData {
  postcode: string;
  id?: string;
  [key: string]: any;
}

const BannerSection = ({ themeData }: any) => {
  const [pinCode, setPinCode] = useState<string>('');
  const [postCodeList, setPostCodeList] = useState<any[]>([]);
  const [selectedPostCode, setSelectedPostCode] = useState<string>('');
  const [error, setError] = useState<string>('');
  const [isLoading, setIsLoading] = useState<boolean>(false);

  const headerData = useSelector((state: RootState) => state.common.header);

  const navigate = useNavigate();
  const dispatch = useDispatch();

  const handlePostcodeSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError('');

    if (!pinCode.trim()) {
      setError('Postcode is required');
      return;
    }

    setIsLoading(true);
    try {
      const response = await getData(`get_shop_by_pincode?pincode=${pinCode}`);

      if (response.status === 200 || response.status === 201) {
        if (response?.data?.success && response?.data?.data?.id) {
          navigate(`${routePrefix}/shop/${response.data.data.id}`);
          dispatch(setCurrentLocation(response.data.data));
        } else {
          setError('No shop found for this postcode');
        }
      }
    } catch (err: any) {
      setError('Area not covered');
    } finally {
      setIsLoading(false);
    }
  };

  const getPostalCode = async () => {
    try {
      const response = await getData(`get_postal_codes?keyword=${pinCode}`);

      if (response.status === 200 || response.status === 201) {
        setPostCodeList(response?.data?.data || []);
      }
    } catch (err) {
      console.error('Failed to fetch postal codes:', err);
      setPostCodeList([]);
    }
  };

  useEffect(() => {
    const debounceTimer = setTimeout(() => {
      if (pinCode && !selectedPostCode) getPostalCode();
    }, 100);

    return () => clearTimeout(debounceTimer);
  }, [pinCode]);

  useEffect(() => {
    if (selectedPostCode) {
      setPinCode(selectedPostCode);
      setPostCodeList([]);
    }
  }, [selectedPostCode]);

  return (
    <>
      <div className="container">
        <div className="row">
          <div className="col-md-12">
            <div className="banner-search-wrap text-center">
              <p
                style={{
                  color:
                    themeData?.theme_2?.home?.section_1?.title_1_color
                      ? `#${themeData.theme_2.home.section_1.title_1_color}`
                      : '#000000',
                }}
              >
                {themeData?.theme_2?.home?.section_1?.title_1}
              </p>
              <h1
                style={{
                  color:
                    themeData?.theme_2?.home?.section_1?.title_2_color
                      ? `#${themeData.theme_2.home.section_1.title_2_color}`
                      : '#000000',
                }}
              >
                {themeData?.theme_2?.home?.section_1?.title_2}
              </h1>
              <p
                style={{
                  color:
                    themeData?.theme_2?.home?.section_1?.title_3_color
                      ? `#${themeData.theme_2.home.section_1.title_3_color}`
                      : '#000000',
                }}
              >
                {themeData?.theme_2?.home?.section_1?.title_3}
              </p>
            </div>
          </div>
        </div>
        <div className="row justify-content-center">
          <div className="col-md-6 mb-4">
            {headerData?.postal_code_enabled == '1' && (
              <div className="postcodeform-container">
                <form onSubmit={handlePostcodeSubmit}>
                  <div>
                    {error && (
                      <small className="text-danger postvalidation">
                        {error}
                      </small>
                    )}
                    <div className="postcodeform">
                      <input
                        name="pinCode"
                        type="text"
                        id="postcode-input"
                        placeholder={`${themeData?.theme_2?.home?.section_1?.btnplaceholder}`}
                        className="ui-autocomplete-input"
                        autoComplete="off"
                        value={pinCode}
                        onChange={(e) => {
                          setPinCode(e.target.value);
                          setError('');
                        }}
                      />
                      <button
                        className="btn hover-btn"
                        id="book_now_btn"
                        type="submit"
                        style={{
                          background: `#${themeData?.theme_2?.home?.section_1?.btnbg_color}`,
                          color: `#${themeData?.theme_2?.home?.section_1?.btncolor}`,
                        }}
                        disabled={isLoading}
                      >
                        {`${themeData?.theme_2?.home?.section_1?.btntext}`}
                      </button>
                      {postCodeList.length > 0 && (
                        <div className="dropdown">
                          {postCodeList.map((data: PostCodeData) => (
                            <div
                              key={data.postcode}
                              className="dropdown-row"
                              onClick={() => setSelectedPostCode(data.postcode)}
                            >
                              <i className="fas fa-map-marker-alt"></i>
                              {data.postcode}
                            </div>
                          ))}
                        </div>
                      )}
                    </div>
                  </div>
                </form>
              </div>
            )}
          </div>
        </div>
        <div className="row">
          <div className="col-md-12">
            <div className="home-img-grid">
              <ul>
                {themeData?.theme_2?.home?.section_1?.card_section.map(
                  (img: any, imgIndex: any) => {
                    return (
                      <>
                        <li className={`${imgIndex == 2 ? 'active' : ''}`}>
                          <img src={img} alt="" />
                        </li>
                      </>
                    );
                  }
                )}
              </ul>
            </div>
          </div>
        </div>
      </div>
      <div
        className="modal fade"
        id="searchmodal"
        aria-hidden="true"
        data-bs-keyboard="false"
      >
        <div className="modal-dialog modal-md modal-dialog-centered">
          <div className="modal-content modal-content-search"></div>
        </div>
      </div>
    </>
  );
};

export default BannerSection;
